/**
 * Utility function for making fetch requests to the API with cache busting
 * 
 * @param {string} endpoint - API endpoint path (without base URL)
 * @param {object} options - Optional fetch options
 * @returns {Promise} - Response data from the API
 */
const API_BASE_URL = 'https://api.bollywoodfunknyc.com';

export const fetchFromAPI = async (endpoint, options = {}) => {
  try {
    // Add cache-busting timestamp parameter
    const separator = endpoint.includes('?') ? '&' : '?';
    const cacheBuster = `${separator}_t=${Date.now()}`;
    
    // Set cache control headers
    const fetchOptions = {
      ...options,
      headers: {
        ...options.headers,
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    };
    
    const response = await fetch(`${API_BASE_URL}${endpoint}${cacheBuster}`, fetchOptions);
    
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('API fetch error:', error);
    throw error;
  }
};

/**
 * Make a POST request to the API
 * 
 * @param {string} endpoint - API endpoint path
 * @param {object} data - Data to send in the request body
 * @returns {Promise} - Response data from the API
 */
export const postToAPI = async (endpoint, data) => {
  return fetchFromAPI(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
};

/**
 * Make a PUT request to the API
 * 
 * @param {string} endpoint - API endpoint path
 * @param {object} data - Data to send in the request body
 * @returns {Promise} - Response data from the API
 */
export const putToAPI = async (endpoint, data) => {
  return fetchFromAPI(endpoint, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
};

/**
 * Make a DELETE request to the API
 * 
 * @param {string} endpoint - API endpoint path
 * @returns {Promise} - Response data from the API
 */
export const deleteFromAPI = async (endpoint) => {
  return fetchFromAPI(endpoint, {
    method: 'DELETE',
  });
};